/**
 * Licensed Materials - Property of HCL Technologies Limited.
 * (C) Copyright HCL Technologies Limited  2023.
 */

import { SxProps, Theme } from '@mui/material';

export const alertSX: SxProps<Theme> = {
	'.MuiAlert-message': {
		whiteSpace: 'normal',
		overflowWrap: 'break-word',
		wordWrap: 'break-word',
		wordBreak: 'break-word',
	},
	backgroundColor: '#F0F7FF',
	boxShadow: '1px 1px 1px 1px rgba(0, 0, 0, 0.2)',
	color: '#011688',
};
